export abstract class Validator<TData> {

    get errors(): string[] {
        return this._errors;
    }

    get hasErrors(): boolean {
        return this._errors.length > 0;
    }

    private _errors: string[] = [];

    public abstract validate(data: TData): boolean;

    public transform<TComp>(transform: (comp: TComp) => TData): FluidValidator<TComp, TData> {
        return new FluidValidator(this, transform);
    }

    public combinate(...validators: Validator<TData>[]): CombinedValidator<TData> {
        return new CombinedValidator(this, ...validators);
    }

    protected setErrors(messages: string[]) {
        this._errors = messages;
    }

    protected setError(message: string) {
        this._errors = [message];
    }

    protected clearErrors() {
        this._errors = [];
    }
}

class FluidValidator<TComp, TData> extends Validator<TComp> {

    private _validator: Validator<TData>;
    private _transform: (comp: TComp) => TData;
    public constructor(origValidator: Validator<TData>, transform: (comp: TComp) => TData) {
        super();
        this._validator = origValidator;
        this._transform = transform;
    }

    public validate(data: TComp): boolean {
        const isValid = this._validator.validate(this._transform(data));
        this.setErrors(this._validator.errors);

        return isValid;
    }
}

class CombinedValidator<TData> extends Validator<TData> {

    private _validators: Validator<TData>[];
    public constructor(firstValidator: Validator<TData>, ...restValidators: Validator<TData>[]) {
        super();
        this._validators = [firstValidator, ...restValidators];
    }

    public validate(data: TData): boolean {
        const isValid = true;
        const validate = (validator: Validator<TData>) => isValid && validator.validate(data);

        this._validators.map(validate);
        this.setErrors(this._validators.flatMap((value) => value.errors));

        return isValid;
    }
}
